// extracted by mini-css-extract-plugin
export var chevronIcon = "_51-2";
export var teamName = "_51-1";
export var teamSwitcherButton = "_51-0";